import React, { useRef, CSSProperties } from 'react'
import { useSelector } from 'react-redux'
import ScrollSpy from 'react-ui-scrollspy';
import { RootState } from 'store'
import { scrollToElement } from 'utils/helpers';
import Overview from './Overview';
import ShareOfVoice from './ShareOfVoice';
import CreatorBreakdown from './CreatorBreakdown';
import CreatorOverlap from './CreatorOverlap';
import { CompetitionGroup, CreatorFollowerTier } from 'types/competition-analysis';

const CompetitionGroupDashboard: React.FC<{ competitionGroup: CompetitionGroup, tiers: CreatorFollowerTier[], isPublicPage?: boolean }> = ({ competitionGroup, tiers = [], isPublicPage = false }) => {
    const parentScrollContainerRef = useRef<HTMLDivElement | null>(null);
    const onPress = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        const target = window.document.getElementById(
            e.currentTarget.href.split("#")[1]
        );
        if (target) {
            scrollToElement(target.id, 'start')
        }
    };

    return (
        <div>
            <div className="container-fluid card">
                <div className="row">
                    <div
                        className="col-md-2 col-sm-2 col-lg-2"
                    >
                        <div className="position-relative w-100">
                            <div>
                                <a onClick={(e) => onPress(e)} href={"#overview"}>
                                    <div
                                        data-to-scrollspy-id="overview"
                                        className="competition-group-dashboard-ss-item"
                                    >
                                        <i className='bx bxs-grid-alt'></i>
                                        Overview
                                    </div>
                                </a>
                                <a onClick={(e) => onPress(e)} href={"#share-of-voice"}>
                                    <div
                                        data-to-scrollspy-id="share-of-voice"
                                        className="competition-group-dashboard-ss-item"
                                    >
                                        <i className='bx bxs-pie-chart-alt-2'></i>
                                        Share Of Voice
                                    </div>
                                </a>
                                <a onClick={(e) => onPress(e)} href={"#creator-breakdown"}>
                                    <div
                                        data-to-scrollspy-id="creator-breakdown"
                                        className="competition-group-dashboard-ss-item"
                                    >
                                        <i className='bx bxs-bar-chart-alt-2'></i>
                                        Creator Breakdown
                                    </div>
                                </a>
                                {
                                    !isPublicPage &&
                                    <a onClick={(e) => onPress(e)} href={"#creator-overlap"}>
                                        <div
                                            data-to-scrollspy-id="creator-overlap"
                                            className="competition-group-dashboard-ss-item"
                                        >
                                            <i className='bx bx-intersect'></i>
                                            Creator Overlap
                                        </div>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-md-10 col-sm-10 col-lg-10 flex-column d-flex justify-content-center p-0">
                        <div
                            ref={parentScrollContainerRef}
                            style={{
                                position: "relative",
                                overflowY: "scroll",
                                height: "80vh",
                            }}
                        >
                            <ScrollSpy
                                parentScrollContainerRef={parentScrollContainerRef}
                                activeClass="competition-group-dashboard-ss-item-active"
                                offsetBottom={100}
                                scrollThrottle={80}
                                useBoxMethod
                            >
                                <div id="overview">
                                    <Overview competitionGroup={competitionGroup} tiers={tiers ?? []} />
                                </div>
                                <div id="share-of-voice">
                                    <ShareOfVoice competitionGroup={competitionGroup} />
                                </div>
                                <div id="creator-breakdown">
                                    <CreatorBreakdown competitionGroup={competitionGroup} tiers={tiers ?? []} />
                                </div>
                                {
                                    !isPublicPage &&
                                    <div id="creator-overlap">
                                        <CreatorOverlap competitionGroup={competitionGroup} />
                                    </div>
                                }
                            </ScrollSpy>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompetitionGroupDashboard
